<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Vyúčtování majitelům licencí</h1>
      <v-layout class="layout--controls">
        <download-excel
          class="v-btn secondary control v-btn--contained theme--light v-size--default button--top"
          :data="json.data"
          :fields="json.labels"
          type="xls"
          :name="json.file"
          :meta="json.meta"
        >
          Exportovat
        </download-excel>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="search"
          v-if="!grouped"
        ></v-text-field>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchGrouped"
          v-if="grouped"
        ></v-text-field>
        <v-btn
          color="primary"
          type="submit"
          class="button--top control"
          @click="groupAudiooboks()"
          ><span v-if="!grouped">Zgrupovat</span
          ><span v-else>Zrušit zgrupování</span></v-btn
        >
        <div class="button--top control">
          <v-autocomplete
            class="control select--top"
            :items="publishers.filter((item) => item.licence)"
            v-model="publisher"
            outlined
            item-value="id"
            item-text="name"
            placeholder="Majitel licence"
            @change="selectPublisher()"
          ></v-autocomplete>
        </div>
      </v-layout>
      <table class="info-table" style="margin-top: 50px" v-if="!grouped">
        <tr>
          <td class="info-table__title">
            Zobrazit od:
          </td>
          <td class="info-table__value info-table__value--date">
            <v-text-field
              class="input--small"
              outlined
              disabled
              v-model="validFrom"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              type="submit"
              class="button--table"
              @click="openDialogValidFrom()"
            >
              Změnit
            </v-btn>
            <v-btn
              color="error"
              type="submit"
              class="button--table"
              @click="data.valid_from = null"
            >
              Zrušit
            </v-btn>
          </td>
        </tr>

        <tr>
          <td class="info-table__title">
            Zobrazit do:
          </td>
          <td class="info-table__value info-table__value--date">
            <v-text-field
              class="input--small"
              outlined
              disabled
              v-model="validTo"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              type="submit"
              class="button--table"
              @click="openDialogValidTo()"
            >
              Změnit
            </v-btn>
            <v-btn
              color="error"
              type="submit"
              class="button--table"
              @click="data.valid_to = null"
            >
              Zrušit
            </v-btn>
          </td>
        </tr>
      </table>

      <v-layout class="table-items" v-if="!grouped">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="30"
          sort-by="created_at"
          :sort-desc="true"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'AudiobooksDetail', params: { id: item.id } }"
                >
                  <td class="">
                    <span
                      v-if="item.image"
                      class="image-table image-table--photo"
                      :style="'background-image:url(' + item.image + ')'"
                    ></span>
                    <span v-else class="image-table"></span>
                  </td>
                  <td class="">{{ item.type }}</td>
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">{{ item.audiobook_name }}</td>

                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'AuthorsDetail',
                        params: { id: item.author_id },
                      }"
                    >
                      {{ item.author_forename }}<br />{{ item.author_surname }}
                    </router-link>
                  </td>
                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'PublishersDetail',
                        params: { id: item.publisher_id },
                      }"
                    >
                      {{ item.publisher_forename }}<br />{{
                        item.publisher_surname
                      }}
                    </router-link>
                  </td>
                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price"> {{ item.price }} Kč </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_no_dph }} Kč</span
                    >
                  </td>

                  <td class="bold">
                    ({{ item.publisher_provision }}%)

                    <span class="actual-price">
                      <span v-if="item.price_provision_publisher">
                        {{ item.price_provision_publisher }} Kč
                      </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_provision_publisher_no_dph }} Kč</span
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
      <v-layout class="table-items" v-else>
        <v-data-table
          locale="cs"
          :headers="headersGrouped"
          :items="itemsGrouped"
          :search="searchGrouped"
          :loading="false"
          item-key="name"
          :items-per-page="30"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'AudiobooksDetail', params: { id: item.id } }"
                >
                  <td class="">
                    <span
                      v-if="item.image"
                      class="image-table image-table--photo"
                      :style="'background-image:url(' + item.image + ')'"
                    ></span>
                    <span v-else class="image-table"></span>
                  </td>
                  <td class="">{{ item.type }}</td>
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">{{ item.audiobook_name }}</td>

                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'AuthorsDetail',
                        params: { id: item.author_id },
                      }"
                    >
                      {{ item.author_forename }}<br />{{ item.author_surname }}
                    </router-link>
                  </td>
                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'PublishersDetail',
                        params: { id: item.publisher_id },
                      }"
                    >
                      {{ item.publisher_forename }}<br />{{
                        item.publisher_surname
                      }}
                    </router-link>
                  </td>

                  <td class="">{{ item.count }}x</td>

                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price"> {{ item.price }} Kč </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_no_dph }} Kč</span
                    >
                  </td>
                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price_all">
                        {{ item.price_all }} Kč
                      </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_all_no_dph }} Kč</span
                    >
                  </td>

                  <td class="bold">
                    ({{ item.publisher_provision }}%)
                    <span class="actual-price">
                      <span v-if="item.price_provision_publisher">
                        {{ item.price_provision_publisher }} Kč
                      </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_provision_publisher_no_dph }} Kč</span
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </div>

    <div class="content content--widget" v-if="loaded">
      <div class="widgets">
        <div class="widgets__row">
          <div class="widget">
            <div class="widget__title">
              Historie
            </div>
            <div class="widget__content" v-for="item in imports">
              <div class="widget-row">
                <span class="widget-row__title"
                  >{{ item.date }} - {{ item.name }}</span
                >

                <v-btn
                  color="error"
                  class="button--control button--mini"
                  @click="openDialogDelete(item)"
                >
                  Smazat
                </v-btn>
              </div>
            </div>
          </div>
          <div class="widget">
            <div class="widget__title">
              Statistiky
            </div>
            <div class="widget__content">
              <div class="widget-row-wrap">
                <div class="widget-row">
                  <span class="widget-row__title">Celkem prodáno</span>
                </div>
                <div class="widget-row">
                  <span class="widget-row__number">{{ items.length }}</span
                  >audioknih
                </div>
                <div class="widget-row">
                  <span class="widget-row__title">za</span>
                </div>
                <div class="widget-row">
                  <span class="widget-row__number"
                    >{{ sumPrice(items).toFixed(2) }} Kč<span
                      class="widget-number-sub"
                      >({{
                        sumPrice(items).toFixed(2) -
                          (sumPrice(items).toFixed(2) / 100) * 10
                      }}
                      Kč bez DPH)</span
                    ></span
                  >
                </div>
                <div class="widget-row">
                  <span class="widget-row__title"
                    >s průměrnou cenou za audioknihu</span
                  >
                </div>
                <div class="widget-row">
                  <span class="widget-row__number"
                    >{{ sumPrice(items).toFixed(2) / items.length }} Kč<span
                      class="widget-number-sub"
                      >({{
                        sumPrice(items).toFixed(2) / items.length -
                          (sumPrice(items).toFixed(2) / items.length / 100) * 10
                      }}
                      Kč bez DPH)</span
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title class="headline">Smazání importu</v-card-title>
        <v-card-text>
          Opravdu si přejete smazat import
          <strong>{{ importData.date }} - {{ importData.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="button--dialog"
            @click="closeDialogDelete()"
          >
            zrušit
          </v-btn>
          <v-btn color="error" class="button--dialog" @click="deleteImport()">
            smazat
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValidFrom" persistent>
      <v-card>
        <v-card-title class="headline">Zobrazit od</v-card-title>
        <v-date-picker
          v-model="data.valid_from"
          locale="cs-cz"
          type="month"
          :max="data.valid_to"
          @click:month="closeDialogValidFrom()"
        ></v-date-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogValidFrom()"
          >
            zrušit
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValidTo" persistent>
      <v-card>
        <v-card-title class="headline">Zobrazit do</v-card-title>
        <v-date-picker
          :min="data.valid_from"
          locale="cs-cz"
          type="month"
          v-model="data.valid_to"
          @click:month="closeDialogValidTo()"
        ></v-date-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogValidTo()"
          >
            zrušit
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';

export default {
  name: 'Billing',
  components: {
    VueJsonToCsv,
  },

  data() {
    return {
      dialogDelete: false,
      importData: {},
      imports: [],
      json: {
        data: [],
        labels: {},
        title: 'Vyúčtování majitelům licencí',
        file: 'Vyúčtování majitelům licencí',
        meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
      },
      grouped: true,
      loaded: false,
      searchGrouped: '',
      search: '',
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: '', value: 'image', sortable: false, align: 'left' },
        { text: 'Typ', value: 'type', align: 'left' },
        { text: 'Období', value: 'audiobook_id', align: 'left' },
        { text: 'Audiokniha', value: 'audiobook_name', align: 'left' },
        { text: 'Autor', value: 'author_forename', align: 'left' },
        { text: 'Majitel licence', value: 'publisher_forename', align: 'left' },
        { text: 'Cena', value: 'price', align: 'left' },
        { text: 'Provize majitele licence', value: 'price', align: 'left' },
      ],
      items: [],
      itemsAll: [],
      headersGrouped: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: '', value: 'image', sortable: false, align: 'left' },
        { text: 'Typ', value: 'type', align: 'left' },
        { text: 'Období', value: 'audiobook_id', align: 'left' },
        { text: 'Audiokniha', value: 'audiobook_name', align: 'left' },
        { text: 'Autor', value: 'author_forename', align: 'left' },
        { text: 'Majitel licence', value: 'publisher_forename', align: 'left' },
        { text: 'Počet kusů', value: 'count', align: 'left' },
        { text: 'Cena za kus', value: 'price', align: 'left' },
        { text: 'Celková cena', value: 'price', align: 'left' },
        { text: 'Provize majitele licence', value: 'price', align: 'left' },
      ],
      itemsGrouped: [],
      itemsGroupedAll: [],
      publishers: [],
      publisher: null,
      dialogValidTo: false,
      dialogValidFrom: false,
      data: {},
    };
  },

  created() {
    this.fetchData();

    this.fetchPublishers();

    this.prepareExport();
  },
  computed: {
    ...mapState(['profile']),

    validTo() {
      if (this.data.valid_to) {
        return moment(this.data.valid_to).format('MM.YYYY');
      } else {
        return null;
      }
    },
    validFrom() {
      if (this.data.valid_from) {
        return moment(this.data.valid_from).format('MM.YYYY');
      } else {
        return null;
      }
    },
  },
  mounted() {},
  methods: {
    openDialogDelete(item) {
      this.importData = {
        date: item.date,
        name: item.name,
        id: item.id,
      };
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.dialogDelete = false;
    },
    deleteImport() {
      this.dialogDelete = false;
      this.$axios
        .delete(
          '/admin/orders/billing/imported/' + this.importData.id + '/delete'
        )
        .then((response) => {
          this.fetchData();
        })
        .catch((e) => {
          this.fetchData();
        });
    },
    sumPrice(items) {
      var value = 0;
      items.forEach((item) => {
        value = value + parseFloat(item.price);
      });

      return value;
    },
    openDialogValidTo() {
      this.dialogValidTo = true;
    },
    closeDialogValidTo() {
      this.dialogValidTo = false;
    },
    openDialogValidFrom() {
      this.dialogValidFrom = true;
    },
    closeDialogValidFrom() {
      this.dialogValidFrom = false;
    },
    groupAudiooboks() {
      this.grouped = !this.grouped;
      this.prepareExport();
    },

    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    fetchData() {
      this.$axios
        .get('/admin/orders/billing/imported')
        .then((response) => {
          this.items = response.data.billing;
          this.itemsGrouped = response.data.billing_grouped;

          this.itemsAll = response.data.billing;
          this.itemsGroupedAll = response.data.billing_grouped;

          this.imports = response.data.imports;

          this.prepareExport();
          this.loaded = true;
        })
        .catch((e) => {
          this.prepareExport();
          this.loaded = true;
        });
    },
    selectPublisher() {
      if (this.$route.query.publisher) {
        this.$router.replace({ query: null });
      }

      this.changeData();
    },
    fetchPublishers() {
      this.$axios
        .get('/admin/publishers')
        .then((response) => {
          this.publishers = response.data.publishers;
          this.publishers.push({
            id: null,
            licence: 1,
            name: 'Všichni vydavatelé',
          });

          if (
            this.$route.query.publisher &&
            this.publishers.find(
              (item) => item.id === this.$route.query.publisher
            )
          ) {
            this.publisher = this.$route.query.publisher;
          }
          this.changeData();
          this.prepareExport();
        })
        .catch((e) => {
          this.prepareExport();
        });
    },
    prepareExport() {
      var jsonData = [];

      if (this.grouped) {
        this.itemsGrouped.forEach((item) => {
          var price = 0;
          if (item.price) {
            price = item.price;
          }

          var price_no_dph = 0;
          if (item.price_no_dph) {
            price_no_dph = item.price_no_dph;
          }

          var price_all = 0;
          if (item.price_all) {
            price_all = item.price_all;
          }

          var price_all_no_dph = 0;
          if (item.price_all_no_dph) {
            price_all_no_dph = item.price_all_no_dph;
          }

          var price_provision = 0;
          if (item.price_provision) {
            price_provision = item.price_provision;
          }

          var price_provision_no_dph = 0;
          if (item.price_provision_no_dph) {
            price_provision_no_dph = item.price_provision_no_dph;
          }

          var price_provision_publisher = 0;
          if (item.price_provision_publisher) {
            price_provision_publisher = item.price_provision_publisher;
          }

          var price_provision_publisher_no_dph = 0;
          if (item.price_provision_publisher_no_dph) {
            price_provision_publisher_no_dph =
              item.price_provision_publisher_no_dph;
          }

          var count = 0;
          if (item.count) {
            count = item.count;
          }

          var publisher_name = item.publisher_forename;
          if (item.publisher_surname) {
            publisher_name =
              item.publisher_forename + ' ' + item.publisher_surname;
          }

          var author_name = item.author_forename;
          if (item.author_surname) {
            author_name = item.author_forename + ' ' + item.author_surname;
          }

          jsonData.push({
            id: item.audiobook_id,
            audiobook: item.audiobook_name,
            type: item.type,
            author: author_name,
            publisher: publisher_name,
            count: count + ' x',
            price: String(price).replace('.', ','),
            price_no_dph: String(price_no_dph).replace('.', ','),
            price_all: String(price_all).replace('.', ','),
            price_all_no_dph: String(price_all_no_dph).replace('.', ','),
            price_provision_publisher: String(
              price_provision_publisher
            ).replace('.', ','),
            price_provision_publisher_no_dph: String(
              price_provision_publisher_no_dph
            ).replace('.', ','),
          });
        });

        this.json.data = jsonData;
        this.json.labels = {
          'ID knihy': 'id',
          Typ: 'type',
          Audiokniha: 'audiobook',
          Autor: 'author',
          'Majitel licence': 'publisher',
          Počet: 'count',
          'Cena za kus': 'price',
          'Cena za kus bez DPH': 'price_no_dph',
          'Celková cena': 'price_all',
          'Celková cena bez DPH': 'price_all_no_dph',
          'Fakturace majitel licence': 'price_provision_publisher',
          'Fakturace majitel licence bez DPH':
            'price_provision_publisher_no_dph',
        };
      } else {
        this.items.forEach((item) => {
          var price = 0;
          if (item.price) {
            price = item.price;
          }

          var price_no_dph = 0;
          if (item.price_no_dph) {
            price_no_dph = item.price_no_dph;
          }

          var publisher_name = item.publisher_forename;
          if (item.publisher_surname) {
            publisher_name =
              item.publisher_forename + ' ' + item.publisher_surname;
          }

          var author_name = item.author_forename;
          if (item.author_surname) {
            author_name = item.author_forename + ' ' + item.author_surname;
          }

          var price_provision_publisher = 0;
          if (item.price_provision_publisher) {
            price_provision_publisher = item.price_provision_publisher;
          }

          var price_provision_publisher_no_dph = 0;
          if (item.price_provision_publisher_no_dph) {
            price_provision_publisher_no_dph =
              item.price_provision_publisher_no_dph;
          }

          jsonData.push({
            id: item.audiobook_id,
            audiobook: item.audiobook_name,
            type: item.type,
            author: author_name,
            publisher: publisher_name,
            price: String(price).replace('.', ','),
            price_no_dph: String(price_no_dph).replace('.', ','),
            price_provision_publisher: String(
              price_provision_publisher
            ).replace('.', ','),
            price_provision_publisher_no_dph: String(
              price_provision_publisher_no_dph
            ).replace('.', ','),
          });
        });

        this.json.data = jsonData;
        this.json.labels = {
          'ID knihy': 'id',
          Typ: 'type',
          Audiokniha: 'audiobook',
          Autor: 'author',
          'Majitel licence': 'publisher',
          Cena: 'price',
          'Cena bez DPH': 'price_no_dph',
          'Fakturace majitel licence': 'price_provision_publisher',
          'Fakturace majitel licence bez DPH':
            'price_provision_publisher_no_dph',
        };
      }

      this.$forceUpdate();
    },
    changeData() {
      var validFrom = null;
      if (this.data.valid_from) {
        validFrom = moment(this.data.valid_from).unix();
      }

      var validTo = null;
      if (this.data.valid_to) {
        validTo = moment(this.data.valid_to)
          .add(24, 'hours')
          .unix();
      }

      if (validFrom && validTo) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter(
            (item) => item.date >= validFrom && item.date <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.date >= validFrom && item.date <= validTo
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.date >= validFrom &&
              item.date <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.date >= validFrom &&
              item.date <= validTo
          );
        }
      } else if (validFrom) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter((item) => item.date >= validFrom);
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.date >= validFrom
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.date >= validFrom
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.date >= validFrom
          );
        }
      } else if (validTo) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter((item) => item.date <= validTo);
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.date <= validTo
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.date <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.date <= validTo
          );
        }
      } else {
        if (this.publisher == null) {
          this.items = this.itemsAll;
          this.itemsGrouped = this.itemsGroupedAll;
        } else {
          this.items = this.itemsAll.filter(
            (item) => item.publisher_id === this.publisher
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.publisher_id === this.publisher
          );
        }
      }

      this.prepareExport();
    },
  },
  watch: {
    'data.valid_from'() {
      this.changeData();
    },
    'data.valid_to'() {
      this.changeData();
    },
  },
};
</script>

<style lang="scss"></style>
